import React from 'react';
import { Box, Typography } from '@mui/material';

// ponytail: shared footer pattern — MUI Box with mt:'auto' in a minHeight:100vh
// flex column layout so the footer sticks to the bottom on short pages and
// follows content on long pages. Mirrors payment-frontend Footer.jsx.
export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: 'text.primary',
        py: 2,
        px: 3,
        mt: 'auto',
        textAlign: 'center',
      }}
    >
      <Box sx={{ display: 'inline-flex', alignItems: 'baseline', gap: 0, mb: 0.5 }}>
        <Typography
          sx={{
            fontFamily: "'Playfair Display', serif",
            fontWeight: 700,
            fontSize: '1.1rem',
            color: 'secondary.main',
          }}
        >
          Raike
        </Typography>
        <Typography
          sx={{
            fontFamily: "'EB Garamond', serif",
            fontStyle: 'italic',
            fontWeight: 300,
            fontSize: '1.35rem',
            color: 'secondary.main',
            mx: '3px',
            lineHeight: 1,
          }}
        >
          &amp;
        </Typography>
        <Typography
          sx={{
            fontFamily: "'Playfair Display', serif",
            fontWeight: 400,
            fontSize: '1.1rem',
            color: 'secondary.main',
          }}
        >
          Sons
        </Typography>
      </Box>
      <Typography
        sx={{
          fontFamily: "'EB Garamond', serif",
          fontStyle: 'italic',
          color: 'background.default',
          opacity: 0.5,
          fontSize: '0.9rem',
          mb: 0.75,
        }}
      >
        Old school hustle. New school AI.
      </Typography>
      <Typography
        sx={{
          fontSize: '0.65rem',
          fontWeight: 600,
          letterSpacing: '0.3em',
          textTransform: 'uppercase',
          color: 'secondary.main',
          opacity: 0.5,
        }}
      >
        Est. 2025
      </Typography>
    </Box>
  );
}